import { ArrowUpRight } from "lucide-react";

const ABOUT_IMAGE =
  "https://customer-assets.emergentagent.com/job_resi-contractor/artifacts/l4co0fqy_IMG_5646.JPG";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#EBE9E2] py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="reveal lg:col-span-6 order-2 lg:order-1">
          <div className="text-xs tracking-[0.25em] uppercase font-bold text-[#9E8262]">
            04 — About Sativa
          </div>
          <h2 className="font-display font-bold text-[#1A1D1A] mt-5 text-4xl sm:text-5xl lg:text-[56px] leading-[1.04] tracking-tight">
            The team behind
            <br />
            <span className="italic font-light text-[#2C4230]">the Z Panel</span> — now
            building your home.
          </h2>
          <div className="font-body text-[#4A524A] mt-7 space-y-5 text-base sm:text-[17px] leading-relaxed">
            <p>
              Sativa Building Systems is best known for our patented hempcrete{" "}
              <strong className="text-[#1A1D1A] font-semibold">Z Panel</strong> —
              an engineered wall block that resists mold, fire, rot, and pests
              while passively filtering indoor air.
            </p>
            <p>
              We&apos;re bringing that same obsession with safe materials and
              superior building science to homeowners across{" "}
              <strong className="text-[#1A1D1A] font-semibold">Central Wisconsin</strong>{" "}
              through our new residential general contracting service.
            </p>
            <p>
              Whether you want a fully conventional build, a hybrid that
              incorporates Z Panel walls, or a fully non-toxic custom home — we
              can build it.
            </p>
          </div>

          <a
            href="https://sativabuildingsystems.com/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="about-learn-more-link"
            className="inline-flex items-center gap-2 mt-9 group text-[#2C4230] hover:text-[#213124] transition-colors"
          >
            <span className="font-semibold text-sm tracking-wide border-b border-[#2C4230] pb-1">
              Learn about Sativa Building Systems
            </span>
            <ArrowUpRight
              size={18}
              className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
            />
          </a>
        </div>

        <div className="reveal lg:col-span-6 order-1 lg:order-2">
          <div className="relative aspect-[4/5] overflow-hidden">
            <img
              src={ABOUT_IMAGE}
              alt="A Sativa Building Systems custom home under construction in Central Wisconsin"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 ring-1 ring-inset ring-black/5" />
            <div className="absolute -bottom-px -right-px bg-[#2C4230] text-[#F4F3EF] p-6 sm:p-8 max-w-[260px]">
              <div className="text-[10px] tracking-[0.25em] uppercase font-bold text-[#C9B07A]">
                Founded On
              </div>
              <div className="font-display font-bold text-xl sm:text-2xl mt-2 leading-snug">
                Healthier homes for the people who live in them.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
